import { forgotPasswordActions } from './actions';
import { ForgotPassword } from './forgotPassword';

export const forgotPasswordReducer = (state = new ForgotPassword(), { payload, type }) => {
    switch (type) {
        case forgotPasswordActions.FETCH_FORGOTPWD_FAILED:
            const { error } = payload;
            return state.merge({
                success: error.success,
                message: error.message,
                isPending: false,
                code: error.code,
                type: error.type,
                belong_to_any_account: error.belong_to_any_account,
                error_description: error.response && error.response.data && error.response.data.message
            });
        case forgotPasswordActions.FETCH_FORGOTPWD_SUCCESS:
            return state.merge({
                success: true,
                message: 'successfully',
                isPending: false,
                data: payload.data || state.data,
                code: payload.code,
                type: payload.type,
                validation_code: state.validation_code || '',
                belong_to_any_account: true,
                reset: false
            });
        case forgotPasswordActions.FETCH_FORGOTPWD_PENDING:
            return state.set('isPending', true);
        
        case forgotPasswordActions.FORGOT_PASSWORD:
            return state.set('action', forgotPasswordActions.FORGOT_PASSWORD);
        case forgotPasswordActions.VERIFY_PASSWORD_CHANGE_CODE:
            return state.set('action', forgotPasswordActions.VERIFY_PASSWORD_CHANGE_CODE).set('validation_code', payload.data.code);
        case forgotPasswordActions.CHANGE_PASSWORD:
            return state.set('action', forgotPasswordActions.CHANGE_PASSWORD);
        case forgotPasswordActions.VALIDATE_INVITATION_TOKENS:
            return state.set('action', forgotPasswordActions.VALIDATE_INVITATION_TOKENS);
        case forgotPasswordActions.RESET_PASSWORD_WITH_TOKENS:
            return state.set('action', forgotPasswordActions.RESET_PASSWORD_WITH_TOKENS);

        case forgotPasswordActions.RESET_STATE:
            return new ForgotPassword();
        default:
            return state;
    }
}